import { useState } from "react";
import SelectMore from "../../../../../components/SelectMore";
import EditPassword from "./editPassword";
import UserCacheUse from "./userCacheUse";

const options = [
  {
    name: "auth.edit_password",
    value: "edit_password"
  },
  {
    name: "domain.cache_use",
    value: "cache_use"
  }
];

export default function UserSelectMore({ user }) {
  const [openModal, setOpenModal] = useState("");

  const handleOpenModal = (name) => {
    setOpenModal(name);
  }

  return (
     <>
       <SelectMore
          options={options}
          openModal={openModal}
          handleOpenModal={handleOpenModal}
       />

       {openModal === "edit_password"
          ? (
             <EditPassword
                user={user}
                setOpen={setOpenModal}
             />
          )
          : null
       }

       {openModal === "cache_use"
          ? (
             <UserCacheUse
                user={user}
                setOpen={setOpenModal}
             />
          )
          : null
       }
     </>
  );
}